module.exports = __webpack_public_path__ + "resources/img/img_intro_certi9.203e1ce04ea561345cd4a2c099d024b7.png";